import { useAppSelector } from '../../hooks/store-hooks';
import ExternalWindow from './ExternalWindow';

export default function ExternalWindows() {
    const windows = useAppSelector((x) => x.workspace.windows);

    return windows.map((windowState) => <ExternalWindow key={windowState.id} window={windowState} />);
}
